export default "__VITE_ASSET__b5d10a39__"